import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.sass';
import HeroBanner from '../../HeroBanner';
import TitleActualizado from '../../TitleActualizado';

const Faq = (props) => {
  const { device } = props;
  const { screenSize } = device;
  const { t } = useTranslation('faq');
  const [faq, setfaq] = useState('carrera');
  const [seeAnswer, setseeAnswer] = useState(0);
  const menu = t('menu', { returnObjects: true });
  const questions = t('questions', { returnObjects: true });

  return (
    <div id={styles.Faq} className={styles[screenSize]}>
      <HeroBanner
        device={device}
        desktopImg='https://webimages.terramarbrands.com.mx/webpage/Faq/banner-faqs-nvo.jpg'
        mobileImg='https://webimages.terramarbrands.com.mx/webpage/Faq/banner-faqs-nvo.jpg'
      />
      <TitleActualizado
        device={device}
        title='Preguntas'
        subtitle='Frecuentes'
        mensaje='Servicio al cliente'
      />

      <div className={styles.container}>
        <div className={styles.menu}>
          <div className={styles.menuHeader}>
            <i className={`material-icons ${styles.menuIcon}`}>list</i>
            <div className={styles.title}>Categorías</div>
          </div>
          <div className={styles.menuContainer}>
            {menu.map((val, key) => {
              return (
                <div key={key} className={styles.nameContainer}>
                  <div className={`${styles.deptName} ${styles[val.code === faq]}`}>
                    <div
                      className={val.code === faq ? styles.categoryUnderline : styles.category}
                      key={key}
                      onClick={() => {
                        setfaq(val.code);
                      }}>
                      {val.name}
                    </div>
                    <i className={`material-icons`}>navigate_next</i>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.leftContainer}>
          {questions.map((val, key) => {
            return (
              <div key={key} className={styles.contentAnswer}>
                <div className={styles.answerBox2}>
                  {val.code === faq && (
                    <div
                      key={key}
                      onClick={() => {
                        setseeAnswer(key === seeAnswer ? null : key); // toggle
                      }}>
                      <div className={`${styles.questionName} ${styles[key === seeAnswer]}`}>
                        <div>{val.pregunta}</div>
                        <i className={`material-icons`}>navigate_next</i>
                      </div>

                      <div className={`${styles.resp} ${key === seeAnswer ? styles.activa : ''}`}>
                        <label>{val.respuesta.split('<br>')}</label>
                      </div>

                      <hr className={styles.hr} />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Faq;
